import {
  IdentityMelcoModelsUserPurchaseListItem,

  UserPurchaseApi,
  useAPIQuery,
  useTable,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

// WHY this mirrors useUsers.ts field-for-field: every other list screen in
// this app (Users, Licenses, ...) follows the same
// useTable + useAPIQuery("<resource>", [...deps]) shape, so a reviewer
// who already knows one of those screens can read this one without
// learning a new pattern. Resist the urge to "improve" this shape locally —
// if something here needs to change, it likely needs to change in all of
// them together.
export const usePurchases = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<IdentityMelcoModelsUserPurchaseListItem>();

  const query = useAPIQuery(
    UserPurchaseApi,
    ["purchases", currentPage, pageSize, filters, sortBy(), searchQuery],
    async (api) => {
      const response = await api.userPurchaseGetList({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        searchText: !isEmpty(searchQuery) ? searchQuery : undefined,
      });

      setTotal(response.total);

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,
    ...query,
  };
};
